module.exports = __webpack_public_path__ + "static/media/comdlg32_533.06c3d2b5.ico";